import React from "react"
import styled from "@emotion/styled"

const FormContainer = styled.form`
  display: grid;
  width: 100%;
  gap: 24px;
`

const TextInput = styled.input`
  border-radius: 4px;
  padding: 10px 18px;
  font-size: 18px;
  background: ${props => props.theme.shade[90]};
  color: ${props => props.theme.shade[0]};
  border: none;
  border: 1px solid ${props => props.theme.shade[70]};
  outline: none;
  width: 100%;
  &::placeholder {
    color: ${props => props.theme.shade[50]};
  }
  &:focus {
    border: none;
    border: 1px solid ${props => props.theme.primary};
  }
`
const TextAreaInput = styled.textarea`
  border-radius: 4px;
  padding: 8px 18px;
  height: 120px;
  font-size: 18px;
  background: ${props => props.theme.shade[90]};
  color: ${props => props.theme.shade[0]};
  border: none;
  border: 1px solid ${props => props.theme.shade[70]};
  outline: none;
  width: 100%;
  &::placeholder {
    color: ${props => props.theme.shade[50]};
  }
  &:focus {
    border: ${props => props.theme.primary} 1px solid;
  }
`
const SubmitButton = styled.button`
  background: ${props => props.theme.primary};
  color: ${props => props.theme.shade[100]};
  padding: 12px 24px;
  border-radius: 24px;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  outline: none;
  border: none;
  max-width: 150px;
  cursor: pointer;
  &:hover {
    background: ${props => props.theme.primary};
  }
`
const Label = styled.label`
  font-size: 0.8rem;
  color: ${props => props.theme.shade[20]};
  text-align: left;
  display: block;
  margin-bottom: 8px;
`
const FormItem = styled.div``

export default function Form() {
  return (
    <FormContainer
      method="POST"
      netlify-honeypot="bot-field"
      data-netlify="true"
      name="Contact"
      action="/thanks"
    >
      <input type="hidden" name="form-name" value="Contact" />
      <FormItem hidden>
        <Label>Don't fill this out if you're human</Label>
        <TextInput placeholder="Name" type="text" name="bot-field" />
      </FormItem>
      <FormItem>
        <Label>Your Name</Label>
        <TextInput
          placeholder="Name"
          id="name"
          type="text"
          name="name"
          required
        />
      </FormItem>
      <FormItem>
        <Label>Email Address</Label>
        <TextInput
          placeholder="Email address"
          id="email"
          type="email"
          name="email"
          required
        />
      </FormItem>
      <FormItem>
        <Label>Message</Label>
        <TextAreaInput
          id="message"
          name="message"
          placeholder="How can we help?"
        />
      </FormItem>
      <SubmitButton type="submit">Submit</SubmitButton>
    </FormContainer>
  )
}
